// extracted by mini-css-extract-plugin
export var innerContainer = "styles-module__innerContainer___M0SZe";
export var mobileContainer = "styles-module__mobileContainer___BOrmh";